@if (vs.currentDirectBuyVehicle(); as vehicle) {
<div class="modal-overlay" [class.closing]="closing()" (click)="close()">
  <div class="modal" [class.closing]="closing()" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <div class="modal-title">Nu Kopen</div>
        <div class="modal-subtitle">{{ vehicle.VehicleSpecification?.Vehicle?.make || '' }} {{ vehicle.VehicleSpecification?.Vehicle?.model || '' }} {{ vehicle.VehicleSpecification?.type || '' }}</div>
      </div>
      <button class="close-btn" (click)="close()">
        <app-icon name="x" size="md" />
      </button>
    </div>
    <div class="modal-body">
      @if (!confirmingBuy()) {
        <div class="direct-buy-info">
          <div class="direct-buy-price-section">
            <div class="direct-buy-price-label">Direct kopen voor ({{ vatLabel }})</div>
            <div class="direct-buy-price">{{ (+(vehicle.salePriceBusiness ?? 0)) | nlCurrency }}</div>
          </div>
          <div class="direct-buy-warning">
            <app-icon name="alert-triangle" size="sm" />
            <span>Let op: Direct kopen is definitief. U kunt dit niet ongedaan maken.</span>
          </div>
          <div class="direct-buy-details">
            <div class="detail-row">
              <span class="detail-label">Taxatienummer</span>
              <span class="detail-value">{{ vehicle.id }}</span>
            </div>
            @if (vehicle.VehicleSpecification?.Vehicle?.registration) {
            <div class="detail-row">
              <span class="detail-label">Kenteken</span>
              <span class="detail-value">{{ vehicle.VehicleSpecification?.Vehicle?.registration }}</span>
            </div>
            }
            @if (vehicle.VehicleSpecification?.mileage) {
            <div class="detail-row">
              <span class="detail-label">Kilometerstand</span>
              <span class="detail-value">{{ vehicle.VehicleSpecification?.mileage || 0 }} km</span>
            </div>
            }
          </div>
        </div>
        <div class="modal-actions">
          <button class="btn-cancel" (click)="close()">Annuleren</button>
          <button class="btn-submit btn-confirm-buy" (click)="initiateBuy()">
            <app-icon name="zap" size="sm" /> Direct Kopen
          </button>
        </div>
      } @else {
        <div class="buy-confirmation">
          <div class="buy-confirmation-text">
            Weet je zeker dat je dit voertuig wilt direct kopen voor <strong>{{ (+(vehicle.salePriceBusiness ?? 0)) | nlCurrency }}</strong>?
          </div>
          <div class="buy-confirmation-warning">
            <app-icon name="alert-triangle" size="md" />
            <span>Deze actie is definitief en kan niet ongedaan worden gemaakt.</span>
          </div>
          <div class="modal-actions">
            <button class="btn-cancel" [disabled]="buying()" (click)="cancelBuy()">Nee, annuleren</button>
            <button class="btn-submit btn-confirm-buy" [disabled]="buying()" (click)="confirmBuy()">
              @if (buying()) {
                <app-icon name="loader" size="sm" /> Bezig met kopen...
              } @else {
                <app-icon name="check" size="sm" /> Ja, direct kopen
              }
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
